// Mirrors the AdminRole values defined in dart-backend's
// lib/modules/admin/domain/entities/admin.dart. Keep in sync with that enum.
export const ROLES = {
  SUPER_ADMIN: "role_super_admin",
  LOGIN: "role_login",
  DASHBOARD_INDEX: "role_dashboard_index",

  ANALYSIS_INDEX: "role_analysis_index",

  ADS_INDEX: "role_ads_index",
  ADS_CREATE: "role_ads_create",
  ADS_EDIT: "role_ads_edit",
  ADS_DELETE: "role_ads_delete",

  ADMIN_INDEX: "role_admin_index",
  ADMIN_CREATE: "role_admin_create",
  ADMIN_EDIT: "role_admin_edit",

  TRANSLATION_INDEX: "role_translation_index",

  CHAT_INDEX: "role_chat_index",

  COMPLAINT_INDEX: "role_complaint_index",
  COMPLAINT_EDIT: "role_complaint_edit",

  COMPLIANCE_RULE_INDEX: "role_compliance_rule_index",
  COMPLIANCE_RULE_CREATE: "role_compliance_rule_create",
  COMPLIANCE_RULE_EDIT: "role_compliance_rule_edit",
  COMPLIANCE_RULE_DELETE: "role_compliance_rule_delete",

  MEDIA_INDEX: "role_media_index",
  MEDIA_EDIT: "role_media_edit",
  MEDIA_DELETE: "role_media_delete",

  MEDIA_COMPLIANCE_RULE_INDEX: "role_media_compliance_rule_index",
  MEDIA_COMPLIANCE_RULE_CREATE: "role_media_compliance_rule_create",
  MEDIA_COMPLIANCE_RULE_EDIT: "role_media_compliance_rule_edit",
  MEDIA_COMPLIANCE_RULE_DELETE: "role_media_compliance_rule_delete",
  BIOMETRIC_SEARCH: "role_biometric_search",

  PAY_INDEX: "role_pay_index",
  PAY_EDIT: "role_pay_edit",

  PAYMENT_METHOD_INDEX: "role_payment_method_index",
  PAYMENT_METHOD_EDIT: "role_payment_method_edit",

  SUPPORT_INDEX: "role_support_index",
  SUPPORT_CREATE: "role_support_create",
  SUPPORT_EDIT: "role_support_edit",

  USER_INDEX: "role_user_index",
  USER_IMPERSONATE: "role_user_impersonate",
  USER_EDIT: "role_user_edit",

  GROWTH_INDEX: "role_growth_index",

  VERIFICATION_INDEX: "role_verification_index",
  VERIFICATION_EDIT: "role_verification_edit",

  EMAIL_MANAGEMENT_INDEX: "role_email_management_index",
  EMAIL_MANAGEMENT_REPLY: "role_email_management_reply",
  EMAIL_MANAGEMENT_DELETE: "role_email_management_delete",
  EMAIL_MANAGEMENT_VIEW_ALL: "role_email_management_view_all",
  EMAIL_MANAGEMENT_ASSIGN: "role_email_management_assign",

  CONFIG_INDEX: "role_config_index",
  CONFIG_EDIT: "role_config_edit",
};

// A super admin implicitly holds every role; otherwise it must be granted
// explicitly. `admin` is the object returned by GET /backoffice/auth/me.
export function hasRole(admin, role) {
  const roles = admin?.roles;
  if (!Array.isArray(roles)) return false;
  return roles.includes(ROLES.SUPER_ADMIN) || roles.includes(role);
}
